class GlobalPromotionPopup extends HTMLElement {
    constructor() {
        super();
        this.exdays = 10;
        this.closed_number = Number(this.dataset.closed_number);
        this.cookie_key = this.dataset.cookie_key;
        this.delay_time = Number(this.dataset.delay_time);
    }
    connectedCallback() {
        this.modal = this.querySelector('#promotion_popup');
        this.displayedCheckbox = this.querySelector('#gp-displayed');
        this.coupon_wrapper = this.querySelector('#coupon_wrapper');

        this.events();
        const cookie_displayed = this.getCookie(`${this.cookie_key}_displayed`);
        if (cookie_displayed === undefined || cookie_displayed === null || cookie_displayed === '') {
            this.setCookie(`${this.cookie_key}_displayed`, false , this.exdays);
        }
        const cookie_closed = this.getCookie(`${this.cookie_key}_closed`);
        if(cookie_closed === undefined || cookie_closed === null || cookie_closed === '') {
            this.setCookie(`${this.cookie_key}_closed`, 0, this.exdays);
        }
        this.showModal();
    }
    closeModal() {
        this.modal.setAttribute('hidden', '');
        document.body.style.overflow = '';
        this.setCookie(`${this.cookie_key}_displayed`, this.displayedCheckbox.checked , this.exdays);
        this.setCookie(`${this.cookie_key}_closed`, Number(this.getCookie(`${this.cookie_key}_closed`)) + 1, this.exdays);
    }
    showModal() {
        if (
            this.getCookie(`${this.cookie_key}_displayed`) === 'true' ||
            Number(this.getCookie(`${this.cookie_key}_closed`)) > this.closed_number
        ) return false;
        setTimeout(() => {
            this.modal.removeAttribute('hidden');
        }, this.delay_time * 1000);
    }
    setCookie(cname,cvalue,exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    events(){
        const _this = this;
        /* ── 关闭事件 ── */
        this.modal.addEventListener('click', function (e) {
            if (e.target.closest('[data-gp-close]')) _this.closeModal();
        });
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') _this.closeModal();
        });
        if (this.coupon_wrapper) {
            this.coupon_wrapper.querySelectorAll('.copy,.code').forEach(function (el) {
                el.addEventListener('click', function (e) {
                    const coupon = _this.coupon_wrapper.querySelector('input[name="coupon_code"]').value;
                    const tips = _this.coupon_wrapper.querySelector('.copy-tips');
                    tips.classList.remove('active');
                    navigator.clipboard.writeText(coupon).then(() => {
                        tips.textContent = 'Copied';
                    }).catch(err => {
                        tips.textContent = 'Copy failed';
                    }).finally(() => {
                        tips.classList.add('active');
                    });
                })
            })

        }
    }
}

customElements.define('global-promotion-popup', GlobalPromotionPopup);
